import React from 'react';
import './HistoryScreen.css'

const HistoryScreen = (props) => {
    return ( 
        <div className='HistoryScreen'>
            <p className='Year'>{props.Year}</p>
            <p className='Event'>{props.Event}</p>
            <p className='Desc'>{props.Desc}</p>
        </div>
     );
}
 
export default HistoryScreen;